import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DoNotBuy() {
  const navigate = useNavigate();

  return (
    <div className="mpd-container mpd-fade-in">
      <div className="mpd-content">
        <h1 className="mpd-title">Please... whatever you do... do NOT buy MyPeopleDatabase</h1>

        <div className="mpd-card">
          <p className="mpd-text">
            Look, we get it. You came here expecting to be convinced. But here are some totally
            reasonable, absolutely rock-solid reasons to avoid purchasing anything today:
          </p>

          <ul className="mpd-text" style={{ textAlign: 'left', margin: '0 auto', maxWidth: 800 }}>
            <li>
              You love chaos. Sticky notes on monitors, mystery spreadsheets named{' '}
              <em>final_final_3.xlsx</em>, and phone numbers stored only in your memory are your
              vibe.
            </li>
            <li>
              You prefer spending weekends "looking for that one email" instead of actually
              contacting people.
            </li>
            <li>
              Organization? Nah. Who needs smart groups, quick search, and tidy exports when you can
              wing it.
            </li>
            <li>
              Automatic updates and future features? Hard pass. You enjoy manually suffering through
              old tools.
            </li>
            <li>
              Clear pricing with a simple checkout? Suspicious. You demand at least seven confusing
              tiers first.
            </li>
          </ul>

          <p className="mpd-text" style={{ marginTop: '1rem' }}>
            If any of that resonates, please keep scrolling the internet aimlessly and definitely do
            not click anything below.
          </p>
        </div>

        <div
          className="mpd-card"
          style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}
        >
          <button className="mpd-button mpd-button-primary" onClick={() => navigate('/download')}>
            Fine, I’ll just Download it first
          </button>
          <button className="mpd-button mpd-button-success" onClick={() => navigate('/buy')}>
            Okay, you got me — Take me to Buy
          </button>
        </div>
      </div>
    </div>
  );
}
